"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeRequest = void 0;
var HomeRequest = /** @class */ (function () {
    function HomeRequest() {
    }
    return HomeRequest;
}());
exports.HomeRequest = HomeRequest;
;
//# sourceMappingURL=home.request.js.map